const getRichMap = () => {
    const richMap = window.rMap;
    if (!richMap || typeof richMap !== 'object') {
        return null;
    }
    return richMap;
};
const invokeRichMapMethod = (methodName, ...args) => {
    const richMap = getRichMap();
    const method = richMap === null || richMap === void 0 ? void 0 : richMap[methodName];
    if (typeof method !== 'function') {
        console.warn(`RichMap method "${methodName}" is unavailable.`);
        return false;
    }
    try {
        method.apply(richMap, args);
        return true;
    }
    catch (error) {
        console.warn(`RichMap method "${methodName}" failed.`, error);
        return false;
    }
};
const isSelectedFloorSourceReady = (richMap = getRichMap()) => {
    try {
        const map = richMap === null || richMap === void 0 ? void 0 : richMap.map;
        if (!map)
            return false;
        if (typeof map.getSource === 'function' &&
            !map.getSource('selected-floor')) {
            return false;
        }
        if (typeof map.isSourceLoaded === 'function') {
            return map.isSourceLoaded('selected-floor');
        }
        return true;
    }
    catch (_error) {
        return false;
    }
};
// Rich Maps does not expose a floor-change completion callback. Listen to the
// underlying source lifecycle and retain a bounded polling fallback for SDK or
// browser versions that do not emit the expected event. The hard timeout keeps
// the UI moving even when source readiness cannot be observed.
const waitForSelectedFloorSource = (onReady, { initialCheckDelayMs = 50, pollIntervalMs = 100, timeoutMs = 5000, } = {}) => {
    var _a;
    const map = (_a = getRichMap()) === null || _a === void 0 ? void 0 : _a.map;
    let settled = false;
    let initialCheckTimer = null;
    let pollTimer = null;
    let timeoutTimer = null;
    const removeListeners = () => {
        if (typeof (map === null || map === void 0 ? void 0 : map.off) === 'function') {
            map.off('sourcedata', handleSourceData);
            map.off('idle', handleIdle);
        }
    };
    const clearTimers = () => {
        if (initialCheckTimer !== null)
            window.clearTimeout(initialCheckTimer);
        if (pollTimer !== null)
            window.clearInterval(pollTimer);
        if (timeoutTimer !== null)
            window.clearTimeout(timeoutTimer);
        initialCheckTimer = null;
        pollTimer = null;
        timeoutTimer = null;
    };
    const cleanup = () => {
        removeListeners();
        clearTimers();
    };
    const finish = () => {
        if (settled)
            return;
        settled = true;
        cleanup();
        onReady();
    };
    const checkReadiness = () => {
        if (!settled && isSelectedFloorSourceReady())
            finish();
    };
    function handleSourceData(event) {
        if (!(event === null || event === void 0 ? void 0 : event.sourceId) || event.sourceId === 'selected-floor') {
            checkReadiness();
        }
    }
    function handleIdle() {
        checkReadiness();
    }
    if (typeof (map === null || map === void 0 ? void 0 : map.on) === 'function') {
        map.on('sourcedata', handleSourceData);
        map.on('idle', handleIdle);
    }
    // Defer the first check so callers can register this waiter immediately
    // before changeFloor() without mistaking the outgoing floor for the new one.
    initialCheckTimer = window.setTimeout(checkReadiness, initialCheckDelayMs);
    pollTimer = window.setInterval(checkReadiness, pollIntervalMs);
    timeoutTimer = window.setTimeout(finish, timeoutMs);
    return () => {
        if (settled)
            return;
        settled = true;
        cleanup();
    };
};
export { getRichMap, invokeRichMapMethod, isSelectedFloorSourceReady, waitForSelectedFloorSource, };
